import React, { useEffect } from 'react';
import { connect, DispatchProp } from 'react-redux';
import { basketActions } from '../../../actions';
import { basketSelectors } from '../../../selectors';
import { useDebouncedCallback } from '../../../utils';

type OrderPayload = ReturnType<typeof basketSelectors.getOrderPayload>;

interface VoucherProps extends DispatchProp<{}> {
  orderPayload: OrderPayload;
}
const Voucher: React.FC<VoucherProps> = props => {
  const { children, orderPayload, dispatch } = props;

  const [checkVoucher, cancelCheckVoucher] = useDebouncedCallback(
    (orderPayload: OrderPayload) => {
      dispatch(basketActions.checkVoucher({ orderPayload }));
    },
    1200,
    {
      // immediately run on first call, next calls debounce
      leading: true
    }
  );

  useEffect(() => {
    if (orderPayload) {
      if (typeof orderPayload !== 'string') {
        checkVoucher(orderPayload);
      }
    }
    return () => {
      cancelCheckVoucher();
    };
  }, [orderPayload]);

  return <div>{children}</div>;
};

export default connect()(Voucher);
